import moment from 'moment';

export interface MapsterProperties {
    fileName: string;
    uploadDate: string;
    fileSize: string;
    county: string;
    mapsterId: string;
    state: string;
    isTiled: boolean;
}

export class Mapster {
    fileName: string;
    uploadDate: moment.Moment;
    county: string;
    mapsterId: string;
    state: string;
    fileSize: string;
    fileSizeInBytes: number;
    isTiled: boolean;

    constructor(data: MapsterProperties) {
        this.fileName = data.fileName;
        this.fileSize = data.fileSize;
        this.uploadDate = moment(data.uploadDate);
        this.county = data.county || 'Not Available';
        this.mapsterId = data.mapsterId;
        this.state = data.state || 'Not Available';
        this.fileSizeInBytes = this.fileSizeMBToBytes(data.fileSize);
        this.isTiled = data.isTiled;
    }

    private fileSizeMBToBytes(fileSize: string): number {
        if (!fileSize) {
            return 0;
        }
        return parseFloat(fileSize) * 1024 * 1024;
    }
}
